import React from "react";
import { MONTHLY_AMOUNT_USD } from "../../lib/billing";

interface FirstChargeAlertProps {
  chargeOn: string;
  onQuit: () => void;
}

const FirstChargeAlert: React.FC<FirstChargeAlertProps> = ({
  chargeOn,
  onQuit,
}) => {
  const date = new Date(chargeOn).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div
      role="status"
      className="bg-warm-bg-elevated border-b border-warm-border px-4 py-3 flex flex-wrap items-center justify-between gap-3"
    >
      <p className="text-sm text-warm-text-primary">
        Your first payment of ${MONTHLY_AMOUNT_USD} is on {date}. Cancel before
        that date and you will not be charged.
      </p>
      <button
        type="button"
        onClick={onQuit}
        className="px-3 py-1.5 text-sm font-medium text-warm-text-primary bg-warm-bg-card border border-warm-border rounded-soft hover:bg-warm-border-subtle transition-colors"
      >
        Cancel
      </button>
    </div>
  );
};

export default FirstChargeAlert;
